
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexFli2tJlxeHMeta } from "/Users/erwannletue/Dev/dearfox/courtinet/pages/[organizationURLPath]/index.vue?macro=true";
import { default as mlm_45parametersN7TmBG1c04Meta } from "/Users/erwannletue/Dev/dearfox/courtinet/pages/admin/mlm-parameters.vue?macro=true";
import { default as organizationsfvPCbdU3T7Meta } from "/Users/erwannletue/Dev/dearfox/genesis/pages/admin/organizations.vue?macro=true";
import { default as users_45batchnM7F4jueapMeta } from "/Users/erwannletue/Dev/dearfox/courtinet/pages/admin/users-batch.vue?macro=true";
import { default as usersTWY9HbpUzrMeta } from "/Users/erwannletue/Dev/dearfox/genesis/pages/admin/users.vue?macro=true";
import { default as loginRbA3vlugfLMeta } from "/Users/erwannletue/Dev/dearfox/genesis/pages/auth/login.vue?macro=true";
import { default as reset_45passwordNF63cuumvjMeta } from "/Users/erwannletue/Dev/dearfox/genesis/pages/auth/reset-password.vue?macro=true";
import { default as sign_45upjnPoKxnj36Meta } from "/Users/erwannletue/Dev/dearfox/genesis/pages/auth/sign-up.vue?macro=true";
import { default as indexEo7bdcXsxsMeta } from "/Users/erwannletue/Dev/dearfox/genesis/pages/index.vue?macro=true";
import { default as _91commissionId_93e7VBY13a4cMeta } from "/Users/erwannletue/Dev/dearfox/courtinet/pages/o/[organizationURLPath]/account/commissions/[commissionId].vue?macro=true";
import { default as index4PSNfZpEM3Meta } from "/Users/erwannletue/Dev/dearfox/courtinet/pages/o/[organizationURLPath]/account/commissions/index.vue?macro=true";
import { default as entitieseZgtVBbGBWMeta } from "/Users/erwannletue/Dev/dearfox/courtinet/pages/o/[organizationURLPath]/account/entities.vue?macro=true";
import { default as networkW2D8MRmkDAMeta } from "/Users/erwannletue/Dev/dearfox/courtinet/pages/o/[organizationURLPath]/account/network.vue?macro=true";
import { default as profile5bwCYbR0fSMeta } from "/Users/erwannletue/Dev/dearfox/courtinet/pages/o/[organizationURLPath]/account/profile.vue?macro=true";
import { default as _91slipId_93sTYoT8AZwpMeta } from "/Users/erwannletue/Dev/dearfox/courtinet/pages/o/[organizationURLPath]/account/slips/[slipId].vue?macro=true";
import { default as index99SCPYuHp6Meta } from "/Users/erwannletue/Dev/dearfox/courtinet/pages/o/[organizationURLPath]/account/slips/index.vue?macro=true";
import { default as _91caseId_93HkruEIv7Z4Meta } from "/Users/erwannletue/Dev/dearfox/courtinet/pages/o/[organizationURLPath]/corporate/cases/[caseId].vue?macro=true";
import { default as indexghFs3R6y7oMeta } from "/Users/erwannletue/Dev/dearfox/courtinet/pages/o/[organizationURLPath]/corporate/cases/index.vue?macro=true";
import { default as _91commissionId_93gvDsGvexh4Meta } from "/Users/erwannletue/Dev/dearfox/courtinet/pages/o/[organizationURLPath]/corporate/commissions/[commissionId].vue?macro=true";
import { default as indexeKkv4pX080Meta } from "/Users/erwannletue/Dev/dearfox/courtinet/pages/o/[organizationURLPath]/corporate/commissions/index.vue?macro=true";
import { default as create_45membergqUYcMs6AKMeta } from "/Users/erwannletue/Dev/dearfox/courtinet/pages/o/[organizationURLPath]/corporate/create-member.vue?macro=true";
import { default as entityGyzCDdcSUfMeta } from "/Users/erwannletue/Dev/dearfox/courtinet/pages/o/[organizationURLPath]/corporate/entities/[entityId]/entity.vue?macro=true";
import { default as indexg7iXRjFoGPMeta } from "/Users/erwannletue/Dev/dearfox/courtinet/pages/o/[organizationURLPath]/corporate/entities/[entityId]/index.vue?macro=true";
import { default as membersC5H85ElmIbMeta } from "/Users/erwannletue/Dev/dearfox/courtinet/pages/o/[organizationURLPath]/corporate/entities/[entityId]/members.vue?macro=true";
import { default as slips7bEzfC5QIUMeta } from "/Users/erwannletue/Dev/dearfox/courtinet/pages/o/[organizationURLPath]/corporate/entities/[entityId]/slips.vue?macro=true";
import { default as _91entityId_93IpMI7FGOpRMeta } from "/Users/erwannletue/Dev/dearfox/courtinet/pages/o/[organizationURLPath]/corporate/entities/[entityId].vue?macro=true";
import { default as indexEXwtEjnPdEMeta } from "/Users/erwannletue/Dev/dearfox/courtinet/pages/o/[organizationURLPath]/corporate/entities/index.vue?macro=true";
import { default as coachq9IZ7Ua0IdMeta } from "/Users/erwannletue/Dev/dearfox/courtinet/pages/o/[organizationURLPath]/corporate/members/[memberUid]/coach.vue?macro=true";
import { default as _91commissionId_93aZ2HT92LJJMeta } from "/Users/erwannletue/Dev/dearfox/courtinet/pages/o/[organizationURLPath]/corporate/members/[memberUid]/commissions/[commissionId].vue?macro=true";
import { default as index4EN1w2vcNkMeta } from "/Users/erwannletue/Dev/dearfox/courtinet/pages/o/[organizationURLPath]/corporate/members/[memberUid]/commissions/index.vue?macro=true";
import { default as entitiesAomPz8zi3dMeta } from "/Users/erwannletue/Dev/dearfox/courtinet/pages/o/[organizationURLPath]/corporate/members/[memberUid]/entities.vue?macro=true";
import { default as generalOb40Z9WuZlMeta } from "/Users/erwannletue/Dev/dearfox/courtinet/pages/o/[organizationURLPath]/corporate/members/[memberUid]/general.vue?macro=true";
import { default as indexwEFiSMYEY4Meta } from "/Users/erwannletue/Dev/dearfox/courtinet/pages/o/[organizationURLPath]/corporate/members/[memberUid]/index.vue?macro=true";
import { default as network1PgojFuaVLMeta } from "/Users/erwannletue/Dev/dearfox/courtinet/pages/o/[organizationURLPath]/corporate/members/[memberUid]/network.vue?macro=true";
import { default as referrerp4lFqDy4OqMeta } from "/Users/erwannletue/Dev/dearfox/courtinet/pages/o/[organizationURLPath]/corporate/members/[memberUid]/referrer.vue?macro=true";
import { default as _91memberUid_93kpvcMfhBuPMeta } from "/Users/erwannletue/Dev/dearfox/courtinet/pages/o/[organizationURLPath]/corporate/members/[memberUid].vue?macro=true";
import { default as indexMhUp9yT5VRMeta } from "/Users/erwannletue/Dev/dearfox/courtinet/pages/o/[organizationURLPath]/corporate/members/index.vue?macro=true";
import { default as _91slipId_9349C0LlxNFzMeta } from "/Users/erwannletue/Dev/dearfox/courtinet/pages/o/[organizationURLPath]/corporate/slips/[slipId].vue?macro=true";
import { default as indexTIIXs1QQ7nMeta } from "/Users/erwannletue/Dev/dearfox/courtinet/pages/o/[organizationURLPath]/corporate/slips/index.vue?macro=true";
import { default as indexJYBo4m4C5SMeta } from "/Users/erwannletue/Dev/dearfox/courtinet/pages/o/[organizationURLPath]/index.vue?macro=true";
import { default as suspendedF2qwBAMAwoMeta } from "/Users/erwannletue/Dev/dearfox/genesis/pages/o/[organizationURLPath]/suspended.vue?macro=true";
import { default as createnNluKbyL5aMeta } from "/Users/erwannletue/Dev/dearfox/genesis/pages/organization/create.vue?macro=true";
import { default as invitationsMwtkM45VdGMeta } from "/Users/erwannletue/Dev/dearfox/genesis/pages/organization/invitations.vue?macro=true";
import { default as _91token_93ybTrmFbrHMMeta } from "/Users/erwannletue/Dev/dearfox/genesis/pages/process/organization-invitation/[organizationId]/[token].vue?macro=true";
import { default as suspendeder6Or1maJhMeta } from "/Users/erwannletue/Dev/dearfox/genesis/pages/suspended.vue?macro=true";
export default [
  {
    name: "organizationURLPath___fr",
    path: "/:organizationURLPath()",
    meta: indexFli2tJlxeHMeta || {},
    component: () => import("/Users/erwannletue/Dev/dearfox/courtinet/pages/[organizationURLPath]/index.vue")
  },
  {
    name: "organizationURLPath___en",
    path: "/en/:organizationURLPath()",
    meta: indexFli2tJlxeHMeta || {},
    component: () => import("/Users/erwannletue/Dev/dearfox/courtinet/pages/[organizationURLPath]/index.vue")
  },
  {
    name: "admin-mlm-parameters___fr",
    path: "/admin/mlm-parameters",
    meta: mlm_45parametersN7TmBG1c04Meta || {},
    component: () => import("/Users/erwannletue/Dev/dearfox/courtinet/pages/admin/mlm-parameters.vue")
  },
  {
    name: "admin-mlm-parameters___en",
    path: "/en/admin/mlm-parameters",
    meta: mlm_45parametersN7TmBG1c04Meta || {},
    component: () => import("/Users/erwannletue/Dev/dearfox/courtinet/pages/admin/mlm-parameters.vue")
  },
  {
    name: "admin-organizations___fr",
    path: "/admin/organizations",
    meta: organizationsfvPCbdU3T7Meta || {},
    component: () => import("/Users/erwannletue/Dev/dearfox/genesis/pages/admin/organizations.vue")
  },
  {
    name: "admin-organizations___en",
    path: "/en/admin/organizations",
    meta: organizationsfvPCbdU3T7Meta || {},
    component: () => import("/Users/erwannletue/Dev/dearfox/genesis/pages/admin/organizations.vue")
  },
  {
    name: "admin-users-batch___fr",
    path: "/admin/users-batch",
    meta: users_45batchnM7F4jueapMeta || {},
    component: () => import("/Users/erwannletue/Dev/dearfox/courtinet/pages/admin/users-batch.vue")
  },
  {
    name: "admin-users-batch___en",
    path: "/en/admin/users-batch",
    meta: users_45batchnM7F4jueapMeta || {},
    component: () => import("/Users/erwannletue/Dev/dearfox/courtinet/pages/admin/users-batch.vue")
  },
  {
    name: "admin-users___fr",
    path: "/admin/users",
    meta: usersTWY9HbpUzrMeta || {},
    component: () => import("/Users/erwannletue/Dev/dearfox/genesis/pages/admin/users.vue")
  },
  {
    name: "admin-users___en",
    path: "/en/admin/users",
    meta: usersTWY9HbpUzrMeta || {},
    component: () => import("/Users/erwannletue/Dev/dearfox/genesis/pages/admin/users.vue")
  },
  {
    name: "auth-login___fr",
    path: "/auth/login",
    meta: loginRbA3vlugfLMeta || {},
    component: () => import("/Users/erwannletue/Dev/dearfox/genesis/pages/auth/login.vue")
  },
  {
    name: "auth-login___en",
    path: "/en/auth/login",
    meta: loginRbA3vlugfLMeta || {},
    component: () => import("/Users/erwannletue/Dev/dearfox/genesis/pages/auth/login.vue")
  },
  {
    name: "auth-reset-password___fr",
    path: "/auth/reset-password",
    meta: reset_45passwordNF63cuumvjMeta || {},
    component: () => import("/Users/erwannletue/Dev/dearfox/genesis/pages/auth/reset-password.vue")
  },
  {
    name: "auth-reset-password___en",
    path: "/en/auth/reset-password",
    meta: reset_45passwordNF63cuumvjMeta || {},
    component: () => import("/Users/erwannletue/Dev/dearfox/genesis/pages/auth/reset-password.vue")
  },
  {
    name: "auth-sign-up___fr",
    path: "/auth/sign-up",
    meta: sign_45upjnPoKxnj36Meta || {},
    component: () => import("/Users/erwannletue/Dev/dearfox/genesis/pages/auth/sign-up.vue")
  },
  {
    name: "auth-sign-up___en",
    path: "/en/auth/sign-up",
    meta: sign_45upjnPoKxnj36Meta || {},
    component: () => import("/Users/erwannletue/Dev/dearfox/genesis/pages/auth/sign-up.vue")
  },
  {
    name: "index___fr",
    path: "/",
    meta: indexEo7bdcXsxsMeta || {},
    component: () => import("/Users/erwannletue/Dev/dearfox/genesis/pages/index.vue")
  },
  {
    name: "index___en",
    path: "/en",
    meta: indexEo7bdcXsxsMeta || {},
    component: () => import("/Users/erwannletue/Dev/dearfox/genesis/pages/index.vue")
  },
  {
    name: "o-organizationURLPath-account-commissions-commissionId___fr",
    path: "/o/:organizationURLPath()/account/commissions/:commissionId()",
    meta: _91commissionId_93e7VBY13a4cMeta || {},
    component: () => import("/Users/erwannletue/Dev/dearfox/courtinet/pages/o/[organizationURLPath]/account/commissions/[commissionId].vue")
  },
  {
    name: "o-organizationURLPath-account-commissions-commissionId___en",
    path: "/en/o/:organizationURLPath()/account/commissions/:commissionId()",
    meta: _91commissionId_93e7VBY13a4cMeta || {},
    component: () => import("/Users/erwannletue/Dev/dearfox/courtinet/pages/o/[organizationURLPath]/account/commissions/[commissionId].vue")
  },
  {
    name: "o-organizationURLPath-account-commissions___fr",
    path: "/o/:organizationURLPath()/account/commissions",
    meta: index4PSNfZpEM3Meta || {},
    component: () => import("/Users/erwannletue/Dev/dearfox/courtinet/pages/o/[organizationURLPath]/account/commissions/index.vue")
  },
  {
    name: "o-organizationURLPath-account-commissions___en",
    path: "/en/o/:organizationURLPath()/account/commissions",
    meta: index4PSNfZpEM3Meta || {},
    component: () => import("/Users/erwannletue/Dev/dearfox/courtinet/pages/o/[organizationURLPath]/account/commissions/index.vue")
  },
  {
    name: "o-organizationURLPath-account-entities___fr",
    path: "/o/:organizationURLPath()/account/entities",
    meta: entitieseZgtVBbGBWMeta || {},
    component: () => import("/Users/erwannletue/Dev/dearfox/courtinet/pages/o/[organizationURLPath]/account/entities.vue")
  },
  {
    name: "o-organizationURLPath-account-entities___en",
    path: "/en/o/:organizationURLPath()/account/entities",
    meta: entitieseZgtVBbGBWMeta || {},
    component: () => import("/Users/erwannletue/Dev/dearfox/courtinet/pages/o/[organizationURLPath]/account/entities.vue")
  },
  {
    name: "o-organizationURLPath-account-network___fr",
    path: "/o/:organizationURLPath()/account/network",
    meta: networkW2D8MRmkDAMeta || {},
    component: () => import("/Users/erwannletue/Dev/dearfox/courtinet/pages/o/[organizationURLPath]/account/network.vue")
  },
  {
    name: "o-organizationURLPath-account-network___en",
    path: "/en/o/:organizationURLPath()/account/network",
    meta: networkW2D8MRmkDAMeta || {},
    component: () => import("/Users/erwannletue/Dev/dearfox/courtinet/pages/o/[organizationURLPath]/account/network.vue")
  },
  {
    name: "o-organizationURLPath-account-profile___fr",
    path: "/o/:organizationURLPath()/account/profile",
    meta: profile5bwCYbR0fSMeta || {},
    component: () => import("/Users/erwannletue/Dev/dearfox/courtinet/pages/o/[organizationURLPath]/account/profile.vue")
  },
  {
    name: "o-organizationURLPath-account-profile___en",
    path: "/en/o/:organizationURLPath()/account/profile",
    meta: profile5bwCYbR0fSMeta || {},
    component: () => import("/Users/erwannletue/Dev/dearfox/courtinet/pages/o/[organizationURLPath]/account/profile.vue")
  },
  {
    name: "o-organizationURLPath-account-slips-slipId___fr",
    path: "/o/:organizationURLPath()/account/slips/:slipId()",
    meta: _91slipId_93sTYoT8AZwpMeta || {},
    component: () => import("/Users/erwannletue/Dev/dearfox/courtinet/pages/o/[organizationURLPath]/account/slips/[slipId].vue")
  },
  {
    name: "o-organizationURLPath-account-slips-slipId___en",
    path: "/en/o/:organizationURLPath()/account/slips/:slipId()",
    meta: _91slipId_93sTYoT8AZwpMeta || {},
    component: () => import("/Users/erwannletue/Dev/dearfox/courtinet/pages/o/[organizationURLPath]/account/slips/[slipId].vue")
  },
  {
    name: "o-organizationURLPath-account-slips___fr",
    path: "/o/:organizationURLPath()/account/slips",
    meta: index99SCPYuHp6Meta || {},
    component: () => import("/Users/erwannletue/Dev/dearfox/courtinet/pages/o/[organizationURLPath]/account/slips/index.vue")
  },
  {
    name: "o-organizationURLPath-account-slips___en",
    path: "/en/o/:organizationURLPath()/account/slips",
    meta: index99SCPYuHp6Meta || {},
    component: () => import("/Users/erwannletue/Dev/dearfox/courtinet/pages/o/[organizationURLPath]/account/slips/index.vue")
  },
  {
    name: "o-organizationURLPath-corporate-cases-caseId___fr",
    path: "/o/:organizationURLPath()/corporate/cases/:caseId()",
    component: () => import("/Users/erwannletue/Dev/dearfox/courtinet/pages/o/[organizationURLPath]/corporate/cases/[caseId].vue")
  },
  {
    name: "o-organizationURLPath-corporate-cases-caseId___en",
    path: "/en/o/:organizationURLPath()/corporate/cases/:caseId()",
    component: () => import("/Users/erwannletue/Dev/dearfox/courtinet/pages/o/[organizationURLPath]/corporate/cases/[caseId].vue")
  },
  {
    name: "o-organizationURLPath-corporate-cases___fr",
    path: "/o/:organizationURLPath()/corporate/cases",
    component: () => import("/Users/erwannletue/Dev/dearfox/courtinet/pages/o/[organizationURLPath]/corporate/cases/index.vue")
  },
  {
    name: "o-organizationURLPath-corporate-cases___en",
    path: "/en/o/:organizationURLPath()/corporate/cases",
    component: () => import("/Users/erwannletue/Dev/dearfox/courtinet/pages/o/[organizationURLPath]/corporate/cases/index.vue")
  },
  {
    name: "o-organizationURLPath-corporate-commissions-commissionId___fr",
    path: "/o/:organizationURLPath()/corporate/commissions/:commissionId()",
    component: () => import("/Users/erwannletue/Dev/dearfox/courtinet/pages/o/[organizationURLPath]/corporate/commissions/[commissionId].vue")
  },
  {
    name: "o-organizationURLPath-corporate-commissions-commissionId___en",
    path: "/en/o/:organizationURLPath()/corporate/commissions/:commissionId()",
    component: () => import("/Users/erwannletue/Dev/dearfox/courtinet/pages/o/[organizationURLPath]/corporate/commissions/[commissionId].vue")
  },
  {
    name: "o-organizationURLPath-corporate-commissions___fr",
    path: "/o/:organizationURLPath()/corporate/commissions",
    component: () => import("/Users/erwannletue/Dev/dearfox/courtinet/pages/o/[organizationURLPath]/corporate/commissions/index.vue")
  },
  {
    name: "o-organizationURLPath-corporate-commissions___en",
    path: "/en/o/:organizationURLPath()/corporate/commissions",
    component: () => import("/Users/erwannletue/Dev/dearfox/courtinet/pages/o/[organizationURLPath]/corporate/commissions/index.vue")
  },
  {
    name: "o-organizationURLPath-corporate-create-member___fr",
    path: "/o/:organizationURLPath()/corporate/create-member",
    component: () => import("/Users/erwannletue/Dev/dearfox/courtinet/pages/o/[organizationURLPath]/corporate/create-member.vue")
  },
  {
    name: "o-organizationURLPath-corporate-create-member___en",
    path: "/en/o/:organizationURLPath()/corporate/create-member",
    component: () => import("/Users/erwannletue/Dev/dearfox/courtinet/pages/o/[organizationURLPath]/corporate/create-member.vue")
  },
  {
    name: _91entityId_93IpMI7FGOpRMeta?.name,
    path: "/o/:organizationURLPath()/corporate/entities/:entityId()",
    component: () => import("/Users/erwannletue/Dev/dearfox/courtinet/pages/o/[organizationURLPath]/corporate/entities/[entityId].vue"),
    children: [
  {
    name: "o-organizationURLPath-corporate-entities-entityId-entity___fr",
    path: "entity",
    component: () => import("/Users/erwannletue/Dev/dearfox/courtinet/pages/o/[organizationURLPath]/corporate/entities/[entityId]/entity.vue")
  },
  {
    name: "o-organizationURLPath-corporate-entities-entityId___fr",
    path: "",
    component: () => import("/Users/erwannletue/Dev/dearfox/courtinet/pages/o/[organizationURLPath]/corporate/entities/[entityId]/index.vue")
  },
  {
    name: "o-organizationURLPath-corporate-entities-entityId-members___fr",
    path: "members",
    component: () => import("/Users/erwannletue/Dev/dearfox/courtinet/pages/o/[organizationURLPath]/corporate/entities/[entityId]/members.vue")
  },
  {
    name: "o-organizationURLPath-corporate-entities-entityId-slips___fr",
    path: "slips",
    component: () => import("/Users/erwannletue/Dev/dearfox/courtinet/pages/o/[organizationURLPath]/corporate/entities/[entityId]/slips.vue")
  }
]
  },
  {
    name: _91entityId_93IpMI7FGOpRMeta?.name,
    path: "/en/o/:organizationURLPath()/corporate/entities/:entityId()",
    component: () => import("/Users/erwannletue/Dev/dearfox/courtinet/pages/o/[organizationURLPath]/corporate/entities/[entityId].vue"),
    children: [
  {
    name: "o-organizationURLPath-corporate-entities-entityId-entity___en",
    path: "entity",
    component: () => import("/Users/erwannletue/Dev/dearfox/courtinet/pages/o/[organizationURLPath]/corporate/entities/[entityId]/entity.vue")
  },
  {
    name: "o-organizationURLPath-corporate-entities-entityId___en",
    path: "",
    component: () => import("/Users/erwannletue/Dev/dearfox/courtinet/pages/o/[organizationURLPath]/corporate/entities/[entityId]/index.vue")
  },
  {
    name: "o-organizationURLPath-corporate-entities-entityId-members___en",
    path: "members",
    component: () => import("/Users/erwannletue/Dev/dearfox/courtinet/pages/o/[organizationURLPath]/corporate/entities/[entityId]/members.vue")
  },
  {
    name: "o-organizationURLPath-corporate-entities-entityId-slips___en",
    path: "slips",
    component: () => import("/Users/erwannletue/Dev/dearfox/courtinet/pages/o/[organizationURLPath]/corporate/entities/[entityId]/slips.vue")
  }
]
  },
  {
    name: "o-organizationURLPath-corporate-entities___fr",
    path: "/o/:organizationURLPath()/corporate/entities",
    component: () => import("/Users/erwannletue/Dev/dearfox/courtinet/pages/o/[organizationURLPath]/corporate/entities/index.vue")
  },
  {
    name: "o-organizationURLPath-corporate-entities___en",
    path: "/en/o/:organizationURLPath()/corporate/entities",
    component: () => import("/Users/erwannletue/Dev/dearfox/courtinet/pages/o/[organizationURLPath]/corporate/entities/index.vue")
  },
  {
    name: _91memberUid_93kpvcMfhBuPMeta?.name,
    path: "/o/:organizationURLPath()/corporate/members/:memberUid()",
    component: () => import("/Users/erwannletue/Dev/dearfox/courtinet/pages/o/[organizationURLPath]/corporate/members/[memberUid].vue"),
    children: [
  {
    name: "o-organizationURLPath-corporate-members-memberUid-coach___fr",
    path: "coach",
    component: () => import("/Users/erwannletue/Dev/dearfox/courtinet/pages/o/[organizationURLPath]/corporate/members/[memberUid]/coach.vue")
  },
  {
    name: "o-organizationURLPath-corporate-members-memberUid-commissions-commissionId___fr",
    path: "commissions/:commissionId()",
    component: () => import("/Users/erwannletue/Dev/dearfox/courtinet/pages/o/[organizationURLPath]/corporate/members/[memberUid]/commissions/[commissionId].vue")
  },
  {
    name: "o-organizationURLPath-corporate-members-memberUid-commissions___fr",
    path: "commissions",
    component: () => import("/Users/erwannletue/Dev/dearfox/courtinet/pages/o/[organizationURLPath]/corporate/members/[memberUid]/commissions/index.vue")
  },
  {
    name: "o-organizationURLPath-corporate-members-memberUid-entities___fr",
    path: "entities",
    component: () => import("/Users/erwannletue/Dev/dearfox/courtinet/pages/o/[organizationURLPath]/corporate/members/[memberUid]/entities.vue")
  },
  {
    name: "o-organizationURLPath-corporate-members-memberUid-general___fr",
    path: "general",
    component: () => import("/Users/erwannletue/Dev/dearfox/courtinet/pages/o/[organizationURLPath]/corporate/members/[memberUid]/general.vue")
  },
  {
    name: "o-organizationURLPath-corporate-members-memberUid___fr",
    path: "",
    component: () => import("/Users/erwannletue/Dev/dearfox/courtinet/pages/o/[organizationURLPath]/corporate/members/[memberUid]/index.vue")
  },
  {
    name: "o-organizationURLPath-corporate-members-memberUid-network___fr",
    path: "network",
    component: () => import("/Users/erwannletue/Dev/dearfox/courtinet/pages/o/[organizationURLPath]/corporate/members/[memberUid]/network.vue")
  },
  {
    name: "o-organizationURLPath-corporate-members-memberUid-referrer___fr",
    path: "referrer",
    component: () => import("/Users/erwannletue/Dev/dearfox/courtinet/pages/o/[organizationURLPath]/corporate/members/[memberUid]/referrer.vue")
  }
]
  },
  {
    name: _91memberUid_93kpvcMfhBuPMeta?.name,
    path: "/en/o/:organizationURLPath()/corporate/members/:memberUid()",
    component: () => import("/Users/erwannletue/Dev/dearfox/courtinet/pages/o/[organizationURLPath]/corporate/members/[memberUid].vue"),
    children: [
  {
    name: "o-organizationURLPath-corporate-members-memberUid-coach___en",
    path: "coach",
    component: () => import("/Users/erwannletue/Dev/dearfox/courtinet/pages/o/[organizationURLPath]/corporate/members/[memberUid]/coach.vue")
  },
  {
    name: "o-organizationURLPath-corporate-members-memberUid-commissions-commissionId___en",
    path: "commissions/:commissionId()",
    component: () => import("/Users/erwannletue/Dev/dearfox/courtinet/pages/o/[organizationURLPath]/corporate/members/[memberUid]/commissions/[commissionId].vue")
  },
  {
    name: "o-organizationURLPath-corporate-members-memberUid-commissions___en",
    path: "commissions",
    component: () => import("/Users/erwannletue/Dev/dearfox/courtinet/pages/o/[organizationURLPath]/corporate/members/[memberUid]/commissions/index.vue")
  },
  {
    name: "o-organizationURLPath-corporate-members-memberUid-entities___en",
    path: "entities",
    component: () => import("/Users/erwannletue/Dev/dearfox/courtinet/pages/o/[organizationURLPath]/corporate/members/[memberUid]/entities.vue")
  },
  {
    name: "o-organizationURLPath-corporate-members-memberUid-general___en",
    path: "general",
    component: () => import("/Users/erwannletue/Dev/dearfox/courtinet/pages/o/[organizationURLPath]/corporate/members/[memberUid]/general.vue")
  },
  {
    name: "o-organizationURLPath-corporate-members-memberUid___en",
    path: "",
    component: () => import("/Users/erwannletue/Dev/dearfox/courtinet/pages/o/[organizationURLPath]/corporate/members/[memberUid]/index.vue")
  },
  {
    name: "o-organizationURLPath-corporate-members-memberUid-network___en",
    path: "network",
    component: () => import("/Users/erwannletue/Dev/dearfox/courtinet/pages/o/[organizationURLPath]/corporate/members/[memberUid]/network.vue")
  },
  {
    name: "o-organizationURLPath-corporate-members-memberUid-referrer___en",
    path: "referrer",
    component: () => import("/Users/erwannletue/Dev/dearfox/courtinet/pages/o/[organizationURLPath]/corporate/members/[memberUid]/referrer.vue")
  }
]
  },
  {
    name: "o-organizationURLPath-corporate-members___fr",
    path: "/o/:organizationURLPath()/corporate/members",
    component: () => import("/Users/erwannletue/Dev/dearfox/courtinet/pages/o/[organizationURLPath]/corporate/members/index.vue")
  },
  {
    name: "o-organizationURLPath-corporate-members___en",
    path: "/en/o/:organizationURLPath()/corporate/members",
    component: () => import("/Users/erwannletue/Dev/dearfox/courtinet/pages/o/[organizationURLPath]/corporate/members/index.vue")
  },
  {
    name: "o-organizationURLPath-corporate-slips-slipId___fr",
    path: "/o/:organizationURLPath()/corporate/slips/:slipId()",
    component: () => import("/Users/erwannletue/Dev/dearfox/courtinet/pages/o/[organizationURLPath]/corporate/slips/[slipId].vue")
  },
  {
    name: "o-organizationURLPath-corporate-slips-slipId___en",
    path: "/en/o/:organizationURLPath()/corporate/slips/:slipId()",
    component: () => import("/Users/erwannletue/Dev/dearfox/courtinet/pages/o/[organizationURLPath]/corporate/slips/[slipId].vue")
  },
  {
    name: "o-organizationURLPath-corporate-slips___fr",
    path: "/o/:organizationURLPath()/corporate/slips",
    component: () => import("/Users/erwannletue/Dev/dearfox/courtinet/pages/o/[organizationURLPath]/corporate/slips/index.vue")
  },
  {
    name: "o-organizationURLPath-corporate-slips___en",
    path: "/en/o/:organizationURLPath()/corporate/slips",
    component: () => import("/Users/erwannletue/Dev/dearfox/courtinet/pages/o/[organizationURLPath]/corporate/slips/index.vue")
  },
  {
    name: "o-organizationURLPath___fr",
    path: "/o/:organizationURLPath()",
    component: () => import("/Users/erwannletue/Dev/dearfox/courtinet/pages/o/[organizationURLPath]/index.vue")
  },
  {
    name: "o-organizationURLPath___en",
    path: "/en/o/:organizationURLPath()",
    component: () => import("/Users/erwannletue/Dev/dearfox/courtinet/pages/o/[organizationURLPath]/index.vue")
  },
  {
    name: "o-organizationURLPath-suspended___fr",
    path: "/o/:organizationURLPath()/suspended",
    meta: suspendedF2qwBAMAwoMeta || {},
    component: () => import("/Users/erwannletue/Dev/dearfox/genesis/pages/o/[organizationURLPath]/suspended.vue")
  },
  {
    name: "o-organizationURLPath-suspended___en",
    path: "/en/o/:organizationURLPath()/suspended",
    meta: suspendedF2qwBAMAwoMeta || {},
    component: () => import("/Users/erwannletue/Dev/dearfox/genesis/pages/o/[organizationURLPath]/suspended.vue")
  },
  {
    name: "organization-create___fr",
    path: "/organization/create",
    meta: createnNluKbyL5aMeta || {},
    component: () => import("/Users/erwannletue/Dev/dearfox/genesis/pages/organization/create.vue")
  },
  {
    name: "organization-create___en",
    path: "/en/organization/create",
    meta: createnNluKbyL5aMeta || {},
    component: () => import("/Users/erwannletue/Dev/dearfox/genesis/pages/organization/create.vue")
  },
  {
    name: "organization-invitations___fr",
    path: "/organization/invitations",
    meta: invitationsMwtkM45VdGMeta || {},
    component: () => import("/Users/erwannletue/Dev/dearfox/genesis/pages/organization/invitations.vue")
  },
  {
    name: "organization-invitations___en",
    path: "/en/organization/invitations",
    meta: invitationsMwtkM45VdGMeta || {},
    component: () => import("/Users/erwannletue/Dev/dearfox/genesis/pages/organization/invitations.vue")
  },
  {
    name: "process-organization-invitation-organizationId-token___fr",
    path: "/process/organization-invitation/:organizationId()/:token()",
    meta: _91token_93ybTrmFbrHMMeta || {},
    component: () => import("/Users/erwannletue/Dev/dearfox/genesis/pages/process/organization-invitation/[organizationId]/[token].vue")
  },
  {
    name: "process-organization-invitation-organizationId-token___en",
    path: "/en/process/organization-invitation/:organizationId()/:token()",
    meta: _91token_93ybTrmFbrHMMeta || {},
    component: () => import("/Users/erwannletue/Dev/dearfox/genesis/pages/process/organization-invitation/[organizationId]/[token].vue")
  },
  {
    name: "suspended___fr",
    path: "/suspended",
    meta: suspendeder6Or1maJhMeta || {},
    component: () => import("/Users/erwannletue/Dev/dearfox/genesis/pages/suspended.vue")
  },
  {
    name: "suspended___en",
    path: "/en/suspended",
    meta: suspendeder6Or1maJhMeta || {},
    component: () => import("/Users/erwannletue/Dev/dearfox/genesis/pages/suspended.vue")
  }
]